<template>
  <div>
    <div class="mb-md-3">
      <!-- Info Guide -->
      <info-guide
        v-if="guideVisibleFirstTime"
        type="profitAndCashFlowExamples"
        visible
        class="mb-3"
        @click="closeInfoFirstTime"
      />
      <!-- /Info Guide -->
      <div class="d-flex justify-content-end margin-guide-not-visible" />
    </div>

    <!-- Profit & Cash Flow Tabs -->
    <profit-and-cash-flow-tabs class="mb-4" />
    <!-- /Profit & Cash Flow Tabs -->

    <!-- Add More Details -->
    <add-more-details
      :category="'forecast'"
      :step="'profit-and-cash-flow'"
      :concept-name="'profitAndCashFlowMoreDetails'"
      :completed-step-name="'profitAndCashFlowCompleted'"
    />
    <!-- /Add More Details -->

    <!-- Info Guide Drawer -->
    <info-guide-drawer
      type="profitAndCashFlowExamples"
      :visible="guideVisible"
      @close="guideVisible = false;"
    />
    <!-- /Info Guide Drawer -->

    <!-- Ai Buddy Drawer -->
    <ai-buddy-drawer
      :visible="aiBuddyDrawerVisible"
      type="profit-and-cash-flow"
      @close="aiBuddyDrawerVisible = false"
    />
    <!-- /Ai Buddy Drawer -->
  </div>
</template>

<script>
import AddMoreDetails from '@/views/Home/StoryMode/Components/AddMoreDetails.vue'
import AiBuddyDrawer from '@/views/Home/StoryMode/Components/AiBuddy/AiBuddyDrawer.vue'
import EventBus from '@/event-bus'
import InfoGuide from '@/views/Home/StoryMode/Components/Example/InfoGuide.vue'
import InfoGuideDrawer from '@/views/Home/StoryMode/Components/Example/InfoGuideDrawer.vue'
import MixinAiBuddyDrawer from '@/mixins/aiBuddyDrawer'
import MixinApiCalculations from '@/mixins/apiCalculations'
import MixinGuide from '@/mixins/guide'
import MixinIdeaRoles from '@/mixins/permissions/ideaRoles'
import MixinTable from '@/mixins/table'
import ProfitAndCashFlowTabs from '@/views/Home/StoryMode/FinancialPlan/Components/ProfitAndCashFlow/ProfitAndCashFlowTabs.vue'
import { mapState } from 'vuex'

export default {
  name: 'ProfitAndCashFlow',

  components: {
    AddMoreDetails,
    ProfitAndCashFlowTabs,
    InfoGuide,
    AiBuddyDrawer,
    InfoGuideDrawer
  },

  mixins: [MixinGuide, MixinTable, MixinIdeaRoles, MixinApiCalculations, MixinAiBuddyDrawer],

  data () {
    return {
      showTables: false
    }
  },

  computed: {
    ...mapState(['idea'])
  },

  watch: {
    profitAndCashFlowHasItemsFromTemplate: {
      handler (value) {
        EventBus.$emit('has-items-from-template', value)
      },
      immediate: true
    }
  },

  mounted () {
    this.openGuide('profitCashFlowFinancialPlanGuide')

    EventBus.$on('open-info', () => {
      this.guideVisible = true
    })

    EventBus.$on('close-info-first-time', () => {
      this.guideVisibleFirstTime = false
    })
  },

  beforeDestroy () {
    EventBus.$off('open-info')
    EventBus.$off('close-info-first-time')
  }
}
</script>
